<!--//@*/*
      //    *RPD  App v0.91
      //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
      //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
      //    */
      //-->

<!-- top -->
<template>
  <div>
    <v-container
      style="width: 100%"
      id="recent-container"
      class="px-0"
      v-if="lst_stats.length > 0"
    >
      <!-- :items="[
                'Print',
                'Print by Week',
                'Print by Month',
                'Download CSV',
                'Pie: Contact %',
                'Pie: Stop Type %',
                'Line: Count by Weeks',
              ]" -->
      <v-card class="mb-3">
        <v-card-text>
          <!-- report button -->
          <!-- @click="go_report" -->
          <!-- to="/report" -->
          <div class="d-flex flex-row justify-start align-start pt-0">
            <div style="width: 200px">
              <!-- add this back when doing tsep forms -->
              <!-- 'TSEP Form', -->
              <v-select
                attach
                class=""
                v-model="report_type"
                :items="['Print', 'Download CSV']"
                :rules="[(v) => !!v || 'Item is required']"
                label="Name/Type"
                required
              ></v-select>
            </div>
            <div class="">
              <v-btn
                @click="go_report"
                color="cmpbk"
                class="white--text px-1 ml-4"
                style="font-size: xx-small; position: relative; top: 13px"
                >Execute Report</v-btn
              >
            </div>
            <v-spacer></v-spacer>
            <div class="">
              <div
                style="
                  line-height: 1;
                  font-size: 1rem;
                  font-weight: 800;
                  position: relative;
                  top: 23px;
                  margin-left: 5px;
                "
              >
                <span class="showcountlbl">Count:</span>
                <span class="showcountlblsmll">Cnt:</span>
                {{ lst_search_results.length }}
              </div>
            </div>
          </div>
        </v-card-text>
      </v-card>
      <v-card
        style="width: 100%"
        :id="'edt' + stat.stat_dataId"
        v-for="stat in lst_search_results"
        :key="stat.id"
        class="mx-auto mb-2 recent-card"
      >
        <v-card-text>
          <v-row dense>
            <v-col cols="12" class="col-md-6 pa-0 d-flex">
              <div class="font-weight-bold">Last modified:</div>
              <p class="mb-0 ml-2">
                {{ stat.s_date | shortDate }}
                <!-- <span class="ml-1">{{ stat.mil_time }}</span> -->
              </p>
            </v-col>
            <v-col cols="12" class="col-md-6 pa-0 d-flex">
              <div class="font-weight-bold">User:</div>
              <p class="mb-0 ml-2">
                {{ stat.s_user }}
              </p>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col cols="12" class="col-md-6 pa-0 d-flex">
              <div class="font-weight-bold">Area:</div>
              <p class="mb-0 ml-2">
                {{ stat.area }}
              </p>
            </v-col>
            <v-col cols="12" class="col-md-6 pa-0 d-flex">
              <div class="font-weight-bold mr-2">Mission:</div>
              <p class="mb-0">
                {{ stat.mission }}
              </p>
            </v-col>
          </v-row>
        </v-card-text>

        <v-container class="checkbox-chips pt-0 mt-2 ml-2">
          <v-row no-gutters dense class="justify-start flex-wrap">
            <v-col
              cols="6"
              md="6"
              class="d-flex justify-start"
              v-if="stat.cites"
            >
              <div class="cnt_disp">
                Cites: <span>{{ stat.cites }}</span>
              </div>
            </v-col>

            <v-col
              cols="6"
              md="6"
              class="d-flex justify-start"
              v-if="stat.misdo_arrests"
            >
              <div class="cnt_disp">
                Misdo Arrests: <span>{{ stat.misdo_arrests }}</span>
              </div>
            </v-col>

            <v-col
              cols="6"
              md="6"
              class="d-flex justify-start"
              v-if="stat.gf_arrests"
            >
              <div class="cnt_disp">
                G/F Arrests: <span>{{ stat.gf_arrests }}</span>
              </div>
            </v-col>

            <v-col
              cols="6"
              md="6"
              class="d-flex flex-wrap justify-start align-content-center"
              v-if="stat.vehicle_posted > 0"
            >
              <div class="cnt_disp">
                Vehicle Posted: <span>{{ stat.vehicle_posted }}</span>
              </div>
            </v-col>
          </v-row>
          <v-row no-gutters dense class="justify-start flex-wrap">
            <v-col
              cols="6"
              md="4"
              class="d-flex justify-start"
              v-if="stat.vehicle_towed"
            >
              <div class="cnt_disp">
                Vehicle Towed: <span>{{ stat.vehicle_towed }}</span>
              </div>
            </v-col>

            <v-col
              cols="6"
              md="4"
              class="d-flex justify-start"
              v-if="stat.help_tickets"
            >
              <div class="cnt_disp">
                Help Tickets: <span>{{ stat.help_tickets }}</span>
              </div>
            </v-col>

            <v-col
              cols="6"
              md="4"
              class="d-flex justify-start"
              v-if="stat.contacts"
            >
              <div class="cnt_disp">
                Contacts: <span>{{ stat.contacts }}</span>
              </div>
            </v-col>
          </v-row>
          <div class="checkbox-chips pt-0 mt-2 ml-2">
            <v-row no-gutters dense class="justify-start flex-wrap">
              <v-col
                cols="6"
                md="6"
                class="d-flex justify-start"
                v-if="stat.deeds_total_fourth_street > 0"
              >
                <div class="cnt_disp">
                  Hours Fourth St.:
                  <span>{{ stat.deeds_total_fourth_street }}</span>
                </div>
              </v-col>

              <v-col
                cols="6"
                md="6"
                class="d-flex justify-start"
                v-if="stat.deeds_citizen_contacts > 0"
              >
                <div class="cnt_disp">
                  Citizen Contacts:
                  <span>{{ stat.deeds_citizen_contacts }}</span>
                </div>
              </v-col>
            </v-row>
            <v-row no-gutters dense class="justify-start flex-wrap">
              <v-col
                cols="6"
                md="6"
                class="d-flex justify-start"
                v-if="stat.deeds_arrests > 0"
              >
                <div class="cnt_disp">
                  Arrests:
                  <span>{{ stat.deeds_arrests }}</span>
                </div>
              </v-col>

              <v-col
                cols="6"
                md="6"
                class="d-flex justify-start"
                v-if="stat.deeds_total_fourth_street > 0"
              >
                <div class="cnt_disp">
                  Citations:
                  <span>{{ stat.deeds_citations }}</span>
                </div>
              </v-col>
            </v-row>
            <v-row no-gutters dense class="justify-start flex-wrap">
              <v-col
                cols="6"
                md="6"
                class="d-flex justify-start"
                v-if="stat.deeds_warnings > 0"
              >
                <div class="cnt_disp">
                  Warnings:
                  <span>{{ stat.deeds_warnings }}</span>
                </div>
              </v-col>

              <v-col
                cols="6"
                md="6"
                class="d-flex justify-start"
                v-if="stat.deeds_calls_service > 0"
              >
                <div class="cnt_disp">
                  Calls For Service:
                  <span>{{ stat.deeds_calls_service }}</span>
                </div>
              </v-col>
            </v-row>

            <v-row no-gutters dense class="justify-start flex-wrap">
              <v-col
                cols="6"
                md="6"
                class="d-flex justify-start"
                v-if="stat.deeds_business_contacts > 0"
              >
                <div class="cnt_disp">
                  Business Contacts:
                  <span>{{ stat.deeds_business_contacts }}</span>
                </div>
              </v-col>

              <v-col
                cols="6"
                md="6"
                class="d-flex justify-start"
                v-if="stat.deeds_planned_operations > 0"
              >
                <div class="cnt_disp">
                  Planned Operations:
                  <span>{{ stat.deeds_planned_operations }}</span>
                </div>
              </v-col>
            </v-row>

            <v-row no-gutters dense class="justify-start flex-wrap">
              <v-col
                cols="6"
                md="6"
                class="d-flex justify-start"
                v-if="stat.deeds_outreach > 0"
              >
                <div class="cnt_disp">
                  Outreach:
                  <span>{{ stat.deeds_outreach }}</span>
                </div>
              </v-col>

              <v-col
                cols="6"
                md="6"
                class="d-flex justify-start"
                v-if="stat.deeds_outreach_accepted > 0"
              >
                <div class="cnt_disp">
                  Outreach Accepted:
                  <span>{{ stat.deeds_outreach_accepted }}</span>
                </div>
              </v-col>
            </v-row>
            <v-row
              no-gutters
              dense
              class="justify-start flex-wrap mt-4"
              v-if="
                stat.deeds_cares_campus != '' && stat.deeds_cares_campus != null
              "
            >
              <v-col cols="12" md="12" class="d-flex justify-start">
                <div style="width: 100%">
                  <label>Use of CARES Campus:</label>
                  <div
                    class="cnt_disp"
                    style="
                      outline: 1px solid black;
                      width: 98%;
                      min-height: 100px;
                    "
                  >
                    <span class="pa-2">{{ stat.deeds_cares_campus }}</span>
                  </div>
                </div>
              </v-col>
            </v-row>
            <v-row
              no-gutters
              dense
              class="justify-start flex-wrap mt-4 mb-4"
              v-if="
                stat.deeds_non_cares_campus != '' &&
                stat.deeds_non_cares_campus != null
              "
            >
              <v-col
                cols="12"
                md="12"
                class="d-flex justify-start"
                v-if="stat.deeds_non_cares_campus != ''"
              >
                <div style="width: 100%">
                  <label>Non Use CARES Campus:</label>
                  <div
                    class="cnt_disp"
                    style="
                      outline: 1px solid black;
                      width: 98%;
                      min-height: 100px;
                    "
                  >
                    <span class="pa-2">{{ stat.deeds_non_cares_campus }}</span>
                  </div>
                </div>
              </v-col>
            </v-row>
          </div>
          <!-- <v-row>
          <v-col cols="12">
            <div class="font-weight-bold mr-2">Details:</div>
            <p>
              {{ stat.details }}
            </p>
          </v-col>
        </v-row> -->
          <v-row>
            <v-col cols="12" class="d-flex justify-space-around">
              <v-btn
                v-if="is_admin"
                v-on:click="edit(stat)"
                color="cmpbk"
                class="white--text"
                style="font-size: smaller"
                >Edit</v-btn
              >
              <v-btn
                v-if="is_admin"
                v-on:click="delete_ask(stat)"
                color="cmpbk"
                class="white--text"
                style="font-size: smaller"
                >Delete</v-btn
              >
              <v-btn
                v-on:click="remove_result(stat)"
                color="cmpbk"
                class="white--text"
                style="font-size: smaller"
                remove_result
                >Remove Result</v-btn
              >
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-container>
    <!-- ********************
       does NOt equal deeds is not right but it only runs this way******  -->
  </div>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";
/* 0 media q */
@media (min-width: 0px) {
  .hide-if-small {
    display: none !important;
  }
  .hide-if-large {
    display: flex;
  }
  .cnt_disp span {
    color: rgb(9, 9, 243);
  }
  .results-card {
    max-width: 344px;
  }

  .accident {
    font-size: smaller;
  }

  .showcountlblsmll {
    display: inline;
  }
  .showcountlbl {
    display: none;
  }
  /*   .accident .v-application--is-ltr::v-deep .v-chip .v-avatar--left {
    margin-right: 0 !important;
  } */
}

/* 768 media q */
@media (min-width: 768px) {
  .hide-if-small {
    display: flex !important;
  }
  .hide-if-large {
    display: none !important;
  }
  .results-card {
    max-width: 90%;
  }
  .showcountlblsmll {
    display: none;
  }
  .showcountlbl {
    display: inline;
  }
}

/* ipad lansdscape */
@media (min-width: 1024px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: landscape) {
}

/* 1025 media q */
@media (min-width: 1025px) {
}

/* 2048 media q */
@media (min-width: 2048px) {
}
</style>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";
const report = () => import("./report.vue");
const mapreport = () => import("./mapreport.vue");
const mapdiag = () => import("./mapdiag.vue");

export default {
  name: "searchResults",
  mixins: [bus_common],
  props: ["lst_search_results", "update_search_results", "sterm"],
  components: { report, mapreport, mapdiag },
  data() {
    return {
      stat_data_map_view: {},
      update_map: null,
      map_view_dialog_visible: false,
      map_dialog_visible: false,
      report_type: "Print",
      lst_stats: [],
      group_size: 6,
      total_loaded: 0,
    };
  },
  watch: {
    lst_search_results: {
      deep: true,
      handler() {
        this.show_loader(true);
        this.lst_stats = this.mno(this.lst_search_results);

        for (let index = 0; index < this.lst_stats.length; index++) {
          var stat = this.lst_stats[index];
          stat.s_date = this.$moment(stat.s_date).format("MM/DD/YYYY");
          stat.s_CreateDate = this.$moment(stat.s_CreateDate).format(
            "MM/DD/YYYY"
          );
        }
        this.show_loader(false);
        //this.$moment(value, 'YYYY-MM-DD', true);
      },
      immediate: true,
    },
  },
  computed: {
    is_admin: function () {
      if (this.$store.state.user.roles.indexOf("cao-admin") > -1) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    show_map(stat) {
      this.stat_data_map_view = stat;
      this.map_view_dialog_visible = true;
    },
    close_view_mapdiag(loc) {
      this.stat_data_map_view = {};
      this.map_view_dialog_visible = false;
    },
    close_mapdiag() {
      this.stat_data_map = {};
      this.map_dialog_visible = false;
    },
    delete_ask(stat) {
      var self = this;
      this.swall_diag(
        "Confirm Delete",
        "You are deleting an item created by '" + stat.s_user + "'. Continue?",
        "question",
        function () {
          self.delete_now(stat);
        },
        null,
        null,
        function () {}
      );
    },
    delete_now(stat) {
      this.$emit("delete_now", stat);
      var index = this.lst_stats.findIndex(
        (item) => item.stat_dataId === stat.stat_dataId
      );
      this.lst_stats.splice(index, 1);
    },
    message1() {
      alert("This button will go to maps");
    },
    message2() {
      alert("This button takes you back to add/edit.");
    },
    message3() {
      alert("This button will delete record");
    },
    message4() {
      alert("This button will sent to records");
    },
    message5() {
      alert("This button will remove from results");
    },
    remove_result(stat) {
      //this.mrbreakpoint("remove");
      var index = this.lst_search_results.findIndex(
        (item) => item.stat_data_cao_Id === stat.stat_data_cao_Id
      );
      this.lst_search_results.splice(index, 1);
    },
    edit(stat) {
      this.$emit("edit", stat);
    },
    go_report() {
      var ids = "";
      var arr_ids = [];
      for (let index = 0; index < this.lst_search_results.length; index++) {
        const stat = this.lst_search_results[index];
        arr_ids.push(stat.stat_data_cao_Id);
      }
      ids = arr_ids.join("|");
      if (this.report_type == "Print") {
        window.open("/print?ids=" + ids);
      }
      //  'TSEP Form'
      if (this.report_type == "TSEP Form") {
        this.$router.push("/tsep_form");
      }
      //pie % contact
      if (this.report_type == "Pie: Contact %") {
        this.$router.push("/piechart");
      }
      //Pie: Stop Type %
      if (this.report_type == "Pie: Stop Type %") {
        this.$router.push("/pie_stop_type");
      }
      if (this.report_type == "Line: Count by Weeks") {
        this.$router.push("/line_cnt_by_weeks");
      }
      if (this.report_type == "Print by Week") {
        window.open("/print/byweek?frm_email=" + this.$store.state.user.email);
      }

      if (this.report_type == "Print by Month") {
        window.open("/print/bymonth?frm_email=" + this.$store.state.user.email);
      }

      if (this.report_type == "Download CSV") {
        //     this.mrbreakpoint("asdf");
        window.open(
          "/mvc_download_csv_cao/cao_data/?&ids=" +
            ids +
            "&email=" +
            this.$store.state.user.email
        );
      }
      if (this.report_type == "Map") {
        this.update_map = new Date();
        this.map_dialog_visible = true;
      }

      return true;
    },
    // downloadFile(filePath) {
    //   var link = document.createElement("a");
    //   link.href = filePath;
    //   link.download = filePath.substr(filePath.lastIndexOf("/") + 1);
    //   link.click();
    // },
    init() {
      setTimeout(() => {
        this.show_loader(false);
      }, 200);
    },
  },
  mounted() {
    this.show_loader(true);
    this.$nextTick(() => {
      this.init();
    });
  },
};
</script>
